import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { payment_and_purchase,  receive,  reports,  calender, functions,  setting } from "../images";

class StepByStep extends Component {
	componentDidMount() {
		if ( this.props.location.pathname === "/step-by-step" ) {
			let offsetTop  = this.instance.getBoundingClientRect().top;
			window.scroll({
				top: offsetTop,
				left: 0,
				behavior: 'smooth'
			});
		}
	}
	render() {
		return (
			<div className="container mt-xl-5 direction-rtl text-center step-by-step-boxs-main-container" id="step-by-step-conainer" ref={(sbs) => this.instance = sbs }>
				<div className="row pb-3 step-by-step-tab-content-title">
					<div className="col-11">
						<h1 className="text-right">راهنما گام به گام</h1>
					</div>
				</div>
			<div className="row mb-4 pr-4 justify-content-center tab-content-container">
				<div className="col-sd-1 ml-5 blank-col">&nbsp;</div>
				<div className="col-sm-3 p-0 pt-4 ml-5 tab-content-box">
					<Link to={"/payment-and-purchase"}>
						<div className="pt-2">
							<div className="tab-content-img-background">
								<img src={payment_and_purchase} alt="پرداخت و خرید"/>
							</div>
							<div className="pt-4 tab-content-text">
								<p>پرداخت و خرید</p>
							</div>
						</div>
					</Link>
				</div>
				<div className="col-sm-3 p-0 pt-4 ml-5 tab-content-box">
					<Link to="/calender">
						<div className="pt-2">
							<div className="tab-content-img-background">
								<img src={calender} alt="تقویم"/>
							</div>
							<div className="pt-4 tab-content-text">
								<p>تقویم</p>
							</div>
						</div>
					</Link>
				</div>
				<div className="col-sm-3 p-0 pt-4 ml-5 tab-content-box">
					<Link to="/receive">
						<div className="pt-2">
							<div className="tab-content-img-background">
								<img src={receive} alt="دریافت ها"/>
							</div>
							<div className="pt-4 tab-content-text">
								<p>دریافت ها</p>
							</div>
						</div>
					</Link>
				</div>
				<div className="col-sd-2 blank-col">&nbsp;</div>
			</div>
			<div className="row mb-4 pr-4 justify-content-center tab-content-container">
				<div className="col-sd-1 ml-5 blank-col">&nbsp;</div>
				<div className="col-sm-3 p-0 pt-4 ml-5 tab-content-box">
					<Link to="/functions">
						<div className="pt-2">
							<div className="tab-content-img-background">
								<img src={functions} alt="کارکردها"/>
							</div>
							<div className="pt-4 tab-content-text">
								<p>کارکردها</p>
							</div>
						</div>
					</Link>
				</div>
				<div className="col-sm-3 p-0 pt-4 ml-5 tab-content-box">
					<Link to="/reports">
						<div className="pt-2">
							<div className="tab-content-img-background">
								<img src={reports} alt="گزارش ها"/>
							</div>
							<div className="pt-4 tab-content-text">
								<p>گزارش ها</p>
							</div>
						</div>
					</Link>
				</div>
				<div className="col-sm-3 p-0 pt-4 ml-5 tab-content-box">
					<Link to="/setting">
						<div className="pt-2">
							<div className="tab-content-img-background">
								<img src={setting} alt="تنظیمات"/>
							</div>
							<div className="pt-4 tab-content-text">
								<p>تنظیمات</p>
							</div>
						</div>
					</Link>
				</div>
				<div className="col-sd-2 blank-col">&nbsp;</div>
		</div>

		</div>
		);
	}
}

export default withRouter(StepByStep);